import React from "react"
import { Switch, Route } from 'react-router-dom'
import { ContentBox } from '@portal/kit/pkg/components'

import OffersList from 'components/offers/offers-list'
import NotFound from 'components/not-found'

import PaymentProvider from 'components/providers/payment'
import OfferDetail from "components/offers/offer-detail"
import Authentication from "../authentication"
import Confirmation from "../confirmation"
import ConfirmationInProgress from "../confirmation-in-progress"


export default function OfferRoutes({ userLogged }) {
  if (!userLogged) return <Route component={NotFound} />

  return (
    <PaymentProvider>
      <ContentBox styles={{ minHeight: 89 }}>
        <Switch>
          <Route exact component={OffersList}     path='/offers' />
          <Route exact component={OfferDetail}    path='/offers/:offerId(\d+)' />
          <Route exact component={Authentication} path='/offers/:offerId(\d+)/checkout' />
          <Route exact component={ConfirmationInProgress} path='/offers/:offerId(\d+)/confirmation-in-progress/:order_id(\d+)' />
          <Route exact component={Confirmation}   path='/offers/:offerId(\d+)/confirmation/:order_id(\d+)' />
          <Route exact component={Confirmation}   path='/offers/:offerId(\d+)/:source(confirmation|regularization)/:order_id(\d+)' />
          <Route component={NotFound} />
        </Switch>
      </ContentBox>
    </PaymentProvider>
  )
}
